import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import LookUpNavigation from 'PointOfSale/modules/lookup/component/LookUpNavigation';
import { changeQueueStatus } from 'PointOfSale/modules/queue/state/actions';
import {
  showLookup,
  resetLookup,
} from 'PointOfSale/modules/lookup/state/actions';
import { QueueStatusEnum } from 'PointOfSale/modules/common/constants';
import * as POSSelectors from 'PointOfSale/selectors';

class LookUpNavigationContainer extends Component {
  onLookupClick = () => {
    const {
      isShowing,
      showLookup,
      resetLookup,
      autoServe,
      changeQueueStatus,
    } = this.props;

    const nextIsShowing = !isShowing;
    showLookup(nextIsShowing);

    if (!nextIsShowing) {
      resetLookup();
    }

    if (nextIsShowing && autoServe) {
      changeQueueStatus(QueueStatusEnum.PAUSED);
    }
  };

  render() {
    return (
      <LookUpNavigation
        onLookupClick={this.onLookupClick}
        isShowing={this.props.isShowing}
      />
    );
  }
}

LookUpNavigationContainer.propTypes = {
  lookUpActions: PropTypes.objectOf(PropTypes.func),
  queueActions: PropTypes.objectOf(PropTypes.func),
};

const mapStateToProps = state => ({
  isShowing: POSSelectors.getShowLookUp(state),
  autoServe: POSSelectors.getAutoServe(state),
});

const mapDispatchToProps = {
  changeQueueStatus,
  showLookup,
  resetLookup,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LookUpNavigationContainer);



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/lookup/container/LookUpNavigationContainer.js